export const mir = [
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2026",
        "url" : "https://s-infraestructura.hidalgo.gob.mx/digital_files/MIR/MIR2026.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2025",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2025.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2024",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2024.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2023",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2023.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2022",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2022.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2021",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2021.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2020",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2020.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2019",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2019.pdf",
        "icon" : "icon-file-pdf"
    },
    {
        "nombre": "Matriz de Indicadores para Resultados",
        "year" : "2018",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/MIR/MIR2018.rar",
        "icon" : "icon-file-rar"
    },
]